//REDUX-TOOLKIT
import { createSlice, PayloadAction } from "@reduxjs/toolkit";


interface State {
    history: any
}

const initialState: State = {
    history: null
}

const slice = createSlice({
    name: "swap",
    initialState,
    reducers: {
        setSwapHistory: (state, action: PayloadAction<any>) => {
            return { ...state, history: action.payload }
        }
    }
})


export const { setSwapHistory } = slice.actions;
export const selectSwapHistory = (state: { swap: State }) => state.swap.history;
export default slice.reducer;